import React from 'react';
import { NavLink } from 'react-router-dom';
import { navLinks } from '../NavLinks';

const SidebarNav: React.FC = () => {
  return (
    <nav className="flex-1 px-3 py-4 space-y-3 overflow-y-auto ">
      {navLinks.map((link) => (
        <NavLink
          key={link.id}
          to={link.to}
          className={({ isActive }) =>
            `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-bold transition-all duration-200 group ${
              isActive
                ? 'bg-primary/10 text-accent border-l-2 border-accent'
                : 'text-gray-600 hover:bg-gray-100 hover:text-accent'
            }`
          }
        >
          <link.icon className="w-5 h-5 transition-transform group-hover:scale-110" />
          <span>{link.label}</span>
        </NavLink>
      ))}
    </nav>
  );
};

export default SidebarNav;